module.exports = __webpack_public_path__ + "img/teamMode_bg2.d97299a2.jpeg";